import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/TPA3DGallery' /* webpackChunkName: "TPA3DGallery" */),
    import(
      './viewer/TPA3DGallery.controller' /* webpackChunkName: "TPA3DGallery" */
    ),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('TPA3DGallery', UiTypes),
};

export default entry;
